import React from 'react';
import PropTypes from 'prop-types';
import Loader from './Loader';
import {publicBuildUrl} from '../../config/config';

const Option = ({loaded, selected, type}) => (
    <div style={{
        ...styles.option,
        opacity: (selected) ? 1 : .5
    }}>
        <img src={`${publicBuildUrl}icons/Icon` + (type === 'OK' ? 'Ok' : 'Nok') + (selected ? 'Selected' : '') + '.png'}
             style={styles.optionImage} alt={''}/>
        <Loader color={(type === 'OK' ? 'green' : 'pink')} loaded={loaded}/>
    </div>
);

Option.prototypes = {
    loaded: PropTypes.number.isRequired,
    selected: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['OK', 'NOK']).isRequired,
};

const styles = {
    option: {
        display: 'flex',
        marginBottom: '25px',
        alignItems: 'center',
    },
    optionImage: {
        width: '50px',
        marginRight: '10px'
    },
}

export default Option;
